import * as React from 'react';
import { IgcCardContentComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * A container component for the card's main text content.
 * This component should be used within an igc-card element to display the primary content.
 * @slot  - Renders the card text content (e.g., paragraphs, lists).
 * @class
 */
export const IgrCardContent = /* @__PURE__ */ createComponent({
  tagName: 'igc-card-content',
  displayName: 'IgrCardContent',
  elementClass: Component,
  react: React,
});

export type IgrCardContent = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrCardContentModule = Component;
